import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import FilterPanel from '../../FilterLayout/FilterPanel';
import { OptionType } from '../../../../../shared/types/filters';
import useFilters from '../../../../../utilities/hooks/useFilters';
import { AgeOptions } from '../../../../../shared/constants/filter/filtersOptions';
import { FilterKeys } from '../../../../../shared/constants/filter/filter';

export default function AgeFilter() {
  const { ageFilter, setAgeFilter } = useFilters();
  const { t } = useTranslation();

  function getSelectedAges() {
    const selected = [] as OptionType<string>[];

    ageFilter.forEach((age) => {
      const res = AgeOptions.find((option) => option.value === age);
      if (res) {
        selected.push({
          label: t('filterAgeValue', { yearValue: res.label }) ?? 'n/a',
          value: res.value,
        });
      }
    });
    return selected;
  }

  function isAgeSelected(value: string) {
    return ageFilter.includes(value);
  }

  function onSelectedAgesChange(value: string) {
    if (ageFilter.includes(value)) {
      setAgeFilter(ageFilter.filter((val) => val !== value));
    } else {
      setAgeFilter([...ageFilter, value]);
    }
  }

  function selectAllAges(
    isChecked: boolean,
    optionsToSelect: any,
    isMatching?: boolean,
  ) {
    if (isChecked || (!isChecked && optionsToSelect.length === 0)) {
      const updatedAges = isMatching
        ? ageFilter.filter((id) => !optionsToSelect.includes(id))
        : [];
      setAgeFilter(updatedAges);
    } else if (optionsToSelect.length > 0) {
      setAgeFilter(
        isMatching
          ? [...ageFilter, ...optionsToSelect.map(String)]
          : optionsToSelect,
      );
    } else {
      setAgeFilter(AgeOptions.map((option) => option.value));
    }
  }

  const localisedOptions = useMemo(
    () =>
      AgeOptions.map(({ label, value }) => ({
        label:
          value === 'NA'
            ? t('filterAgeValue', { yearValue: t(label) }).replace(
                String(t('YEARS')),
                '',
              )
            : t('filterAgeValue', { yearValue: label }) ?? 'n/a',
        value,
      })),
    [],
  );

  return (
    <FilterPanel<string>
      name="age"
      filterKey={FilterKeys.age}
      options={localisedOptions}
      isSelected={isAgeSelected}
      onSelectedChange={onSelectedAgesChange}
      selectedItems={getSelectedAges()}
      selectAllItems={selectAllAges}
      flatItemArray={AgeOptions}
    />
  );
}
